import { useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import Input from "components/common/Input";
import useClockSessionMutations from "graphql/useClockSessionMutations";
import useClockInMutations from "graphql/useclockInMutations";
import { useMessaging } from "context/MessagingContext";
import useWindowSize from "useWindowSize";
import s from "../styles";
import ls from "components/common/ListWithMoreOptions/ItemRow/styles";
import { useFormik } from "formik";
import { DatePicker, Skeleton } from "antd";
import Colors from "assets/Colors";
import { useClockSessionById } from "../../../graphql/useClockSessions";
import {
  getClockSessionDurationForUpdate,
  getUpdateObject,
} from "../../../helpers/utils";
import { disabledDate, disabledTime } from "helpers/dataHelper";

// const isValidDate = (date, constraints) => {
//   if (!date) return true;
//   if (constraints) {
//     const { previous, next } = constraints;
//     if (previous && date.isBefore(previous)) {
//       return false;
//     }
//     if (next && date.isAfter(next)) {
//       return false;
//     }
//   }
//   return true;
// };

// const isValidDateTime = (dateTime, constraints) => {
//   if (!dateTime) return true;

//   if (constraints) {
//     const { previous, next } = constraints;
//     /**
//      if (partnerItem && moment(dateTime).isBefore(partnerItem.clockDatetime)) {
//      return false;
//      }
//      */
//     if (previous && moment(dateTime).isBefore(previous)) {
//       return false;
//     }
//     if (next && moment(dateTime).isAfter(next)) {
//       return false;
//     }
//   }
//   return true;
// };

const ClockInRowForm = ({ item, actions, setUpdating }) => {
  const { t } = useTranslation();

  const { updateClockSession } = useClockSessionMutations(item.storeId);

  const { updateClockIn } = useClockInMutations(item.storeId);

  const { setInfoMessage, setErrorMessage } = useMessaging();

  const { width } = useWindowSize();

  const [saving, setSaving] = useState(false);

  /**
   * this is the chained session
   */
  const { clockSession: chainSession, loading: loading1 } = useClockSessionById(
    item.chainSessionId
  );
  /**
   * this is the main session
   */
  const { clockSession, loading: loading2 } = useClockSessionById(
    item.sessionId
  );

  const onUpdateSuccess = useCallback(() => {
    setInfoMessage({
      titleAlert: t("containers.ClockSessions.dataModified"),
      info1: t("containers.ClockSessions.dataModifiedFind"),
    });
  }, [t]);

  const isStart = item.type === "in";
  /*
  console.log("****** item", item, isStart);
  console.log(
    "****** chainSession",
    chainSession?._id,
    chainSession?.type,
    chainSession?.sessionStart,
    chainSession?.sessionEnd
  );
  console.log(
    "****** clockSession",
    clockSession?.__typename,
    clockSession?._id,
    clockSession?.type,
    clockSession?.sessionStart,
    clockSession?.sessionEnd
  );
  */

  const [endSession, startSession] = useMemo(() => {
    if (isStart) {
      return [undefined, clockSession];
    }
    return [clockSession, chainSession];
  }, [isStart, clockSession, chainSession]);

  // console.log("chainSession", chainSession);

  // console.log("******", endSession, startSession);

  // console.log("startSession", startSession);
  // console.log("endSession", endSession);

  const { handleSubmit, setFieldValue, isValid, dirty, values } = useFormik({
    enableReinitialize: true,
    initialValues: { ...item, __typename: undefined },
    onSubmit: async (values) => {
      setSaving(true);
      const updateDatetime = new Date();
      const clockDatetime = moment(values.clockDatetime).toDate();
      try {
        // this clock In ends a session
        if (endSession) {
          // there is a clock session linked
          const toUpdateEndSession = getUpdateObject(endSession);
          await updateClockSession(endSession, {
            ...toUpdateEndSession,
            updateDatetime,
            updated: true,
            sessionEnd: clockDatetime,
            sessionDuration: getClockSessionDurationForUpdate(
              toUpdateEndSession.sessionStart,
              clockDatetime
            ),
          });
        }
        // this clock in starts a session
        if (startSession) {
          const toUpdateStartSession = getUpdateObject(startSession);
          await updateClockSession(startSession, {
            ...toUpdateStartSession,
            updateDatetime,
            updated: true,
            sessionStart: clockDatetime,
            sessionDuration: getClockSessionDurationForUpdate(
              clockDatetime,
              toUpdateStartSession.sessionEnd
            ),
          });
        }
        const toUpdate = {
          ...values,
          updated: true,
          clockDatetime: moment(values.clockDatetime).toDate(),
        };
        await updateClockIn(item, toUpdate);
        setUpdating(false);
        onUpdateSuccess();
      } catch (error) {
        setErrorMessage({ error });
      } finally {
        setSaving(false);
      }
    },
  });

  if (loading1 || loading2) {
    return [
      <Skeleton
        key="clockInRowFormDateTime"
        active
        paragraph={{ rows: 0 }}
        style={{ width: "100%" }}
      />,
      <Skeleton
        key="clockInRowFormAction"
        active
        paragraph={{ rows: 0 }}
        style={{ width: "100%" }}
      />,
      <Skeleton
        key="clockInRowFormNotes"
        active
        paragraph={{ rows: 0 }}
        style={{ width: "100%" }}
      />,
    ];
  }

  return [
    <DatePicker
      key="clockInRowFormDateTime"
      style={{ maxWidth: "200px", marginLeft: "20px" }}
      disabled={chainSession?.status === "open"}
      defaultValue={item.clockDatetime ? moment(item.clockDatetime) : null}
      format="YYYY-MM-DD hh:mm A"
      showTime
      disabledDate={(current) =>
        disabledDate(
          current,
          endSession?.sessionStart,
          startSession?.sessionEnd
        )
      }
      disabledTime={(current) =>
        disabledTime(
          current,
          endSession?.sessionStart,
          startSession?.sessionEnd
        )
      }
      onChange={(newTime) => {
        const newTimeWithoutSeconds = moment(newTime)
          .seconds(0)
          .milliseconds(0);
        setFieldValue("clockDatetime", newTimeWithoutSeconds);
      }}
    />,
    <ls.TableCell key="clockInRowFormAction">
      {actions[item.type]}
    </ls.TableCell>,
    <Input
      key="clockInRowFormNotes"
      placeholder="-"
      style={{
        width: width < 720 ? "100%" : "160px",
      }}
      value={values.notes}
      onChange={(notes) => {
        setFieldValue("notes", notes.target.value);
      }}
    />,
    <div
      key="clockInRowFormActionButtons"
      style={{
        display: "flex",
        justifyContent: "end",
        gap: "10px",
        width: "100%",
        paddingRight: "20px",
      }}
    >
      <s.button
        onClick={() => {
          setUpdating(false);
        }}
      >
        {t("containers.ClockSessions.cancel")}
      </s.button>
      <s.button
        disabled={!isValid || !dirty}
        loading={saving}
        background={Colors.primary}
        onClick={() => handleSubmit()}
      >
        {t("containers.ClockSessions.finish")}
      </s.button>
    </div>,
  ];
};

export default ClockInRowForm;
